import * as api from "../generated-api";
import { apiCall } from "../common";
import { AxiosError } from "axios";

export const updateSignatureBlock = (
  orgId: number,
  dealId: number,
  dealLegalEntityId: number,
  signatureBlock: api.SignatureBlockUpdate,
  successCallback?: (signatureBlock: api.SignatureBlock) => void,
  errorCallback?: (error: Error) => void
) => {
  apiCall<api.SignatureBlock>(
    () => {
      return api.updateSignatureBlock(
        orgId,
        dealId,
        dealLegalEntityId,
        signatureBlock
      );
    },
    successCallback,
    errorCallback
  );
};

export const getSignatureBlock = (
  orgId: number,
  dealId: number,
  dealLegalEntityId: number,
  successCallback?: (signatureBlock: api.SignatureBlock) => void,
  errorCallback?: (error: AxiosError) => void
) => {
  apiCall<api.SignatureBlock>(
    () => {
      return api.getSignatureBlock(orgId, dealId, dealLegalEntityId);
    },
    successCallback,
    errorCallback
  );
};

export const createSignatureBlockWithContentPreview = (
  orgId: number,
  dealId: number,
  dealLegalEntityId: number,
  isEntity: boolean,
  personName: string,
  personEmail: string,
  title: string,
  intermediateBy: string,
  intermediateIts: string,
  successCallback?: (signatureBlock: api.SignatureBlockWithContent) => void,
  errorCallback?: (error: AxiosError) => void
) => {
  apiCall<api.SignatureBlockWithContent>(
    () => {
      return api.createSignatureBlockWithContentPreview(
        orgId,
        dealId,
        dealLegalEntityId,
        {
          isEntity,
          personName,
          personEmail,
          title,
          intermediateBy,
          intermediateIts,
        }
      );
    },
    successCallback,
    errorCallback
  );
};
